<script setup lang="ts">
import { Components } from '@/api/generated/api';
import type { TEntityAppearance } from '@/core/entity-appearance/entityAppearance.types';
import ClassOverview from '@/core/dialogs/create-class/ClassOverview.vue';
import EmptyPlaceholder from '@/core/elements/EmptyPlaceholder.vue';
import UserAccessRightDisplayListItem from '@/core/list-items/UserAccessRightDisplayListItem.vue';
import { IUserWithPermissions } from '@/interfaces';

defineProps<{
  generalData: Components.Schemas.SchoolClassDto | Components.Schemas.CreateSchoolClassDto | null;
  appearance: TEntityAppearance;
  schoolSubjects: Components.Schemas.SchoolSubjectDto[];
  team: IUserWithPermissions[];
  studentCount: number;
}>();
</script>

<template>
  <div class="grid h-full grid-rows-[auto_auto_1fr_auto] px-lg md:px-content">
    <p class="text-subtitle mb-md">{{ $t('classes.finalizeDescription') }}</p>

    <ClassOverview :school-class="generalData" :student-count="studentCount" :preview-appearance="appearance" />

    <div class="mt-lg flex min-w-0 flex-col gap-sm">
      <div class="font-semibold">{{ $t('accessRights.currentStaffDescription') }}</div>
      <ul class="flex min-w-0 flex-col gap-sm">
        <UserAccessRightDisplayListItem
          v-for="teamMember in team"
          :key="teamMember.user.id"
          :user="teamMember"
          :school-subjects="schoolSubjects"
        />
      </ul>
      <EmptyPlaceholder :data="team" class="h-min" />
    </div>
  </div>
</template>
